import React, { FC, useMemo } from 'react';

import { MenuObjectTypes } from 'enums/menu';
import { useProductWizardContext } from 'state/product-wizard-v2';
import useProductWizardFlow from 'state/product-wizard-v2/hooks/use-product-wizard-flow';
import { isCombo } from 'utils/menu';

import { DEFAULT_SLOT_KEY } from '../../product-detail-flow/product-item-flow/constants';
import { ModifierGroupContainer } from '../styled';
import { IProductCustomizationModifiersProps } from '../types';

import { ModifierGroup } from './product-customization-modifier-group';
import { IModifierGroup } from './types';
import { groupModifiersByDisplayName } from './utils';

export const ProductCustomizationModifiers: FC<IProductCustomizationModifiersProps> = ({
  modifierSelections,
  onModifierSelectionsChange,
  pickerAspectExclusions,
  selectedItem,
  hasMultipleComboSlotOptions = false,
}) => {
  const { options: selectedItemModifiers } = selectedItem;
  const { menuObject, updateSelectionStateWithId } = useProductWizardContext();
  const { slotKeyToCustomize } = useProductWizardFlow();

  const modifierGroupsProps = useMemo<IModifierGroup[]>(() => {
    if (!selectedItemModifiers?.length) {
      return [];
    }

    return groupModifiersByDisplayName(
      selectedItemModifiers,
      modifierSelections,
      pickerAspectExclusions
    );
  }, [selectedItemModifiers, modifierSelections, pickerAspectExclusions]);

  return (
    <ModifierGroupContainer testID="product-customization-modifiers">
      {modifierGroupsProps.map(modifierGroupProps => (
        <ModifierGroup
          {...modifierGroupProps}
          key={modifierGroupProps.key ?? modifierGroupProps.displayGroupName}
          isFullContainer={hasMultipleComboSlotOptions}
          onModifierSelectionChange={(selections, modifier) => {
            onModifierSelectionsChange(selections, modifier);
            updateSelectionStateWithId({
              id: slotKeyToCustomize || DEFAULT_SLOT_KEY,
              isDirty: true,
              type: isCombo(menuObject) ? MenuObjectTypes.COMBO_SLOT : MenuObjectTypes.ITEM,
            });
          }}
          selectedItem={selectedItem}
        />
      ))}
    </ModifierGroupContainer>
  );
};
